import React, { useEffect, useState } from "react";
import GRNServices from "../../../Purchase/GRN/GRNServices";
import {
  currentTenant,
  financialyearend,
  financialyearstart,
  thousandsdisplay,
  userid,
  currency,
} from "../../../Common/Credentials";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Collapse,
  IconButton,
} from "@mui/material";
import moment from "moment";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { NumericFormat } from "react-number-format";
import { Link } from "react-router-dom";

const Payables = ({ data, poloader, theme }) => {
  const [grns, setGrns] = useState([]);
  const [supplierlist, setSupplierlist] = useState([]);
  const [page, setPages] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalDue, setTotalDue] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);

  useEffect(() => {
    let datadao = {
      tenantid: currentTenant,
      startdate: financialyearstart,
      enddate: financialyearend,
      userid: userid,
      dataaccess: "All",
    };
    GRNServices.retriveAllActiveGRN(datadao).then((res) => {
      setGrns(res.data);
      const suppliers = res.data.reduce(
        (
          sup,
          {
            customgrnid,
            custompoid,
            grnid,
            poid,
            balance,
            totalprice,
            supplier,
            supplierid,
            createdAt,
          }
        ) => {
          if (!sup[supplier]) sup[supplier] = [];
          sup[supplier].push({
            grnid: grnid,
            customgrnid: customgrnid,
            custompoid: custompoid,
            grnid: grnid,
            poid: poid,
            balance: balance,
            totalprice: totalprice,
            supplier: supplier,
            supplierid: supplierid,
            createdAt: createdAt,
          });
          return sup;
        },
        {}
      );
      let list = [];
      Object.entries(suppliers).forEach(([key, value]) => {
        let a = {
          supplier: key,
          supplierid: value.map((e) => e.supplierid)[0],
          balance: value.reduce((a, v) => (a = a + v.balance), 0),
          totalprice: value.reduce((a, v) => (a = a + v.totalprice), 0),
        };
        list.push(a);
      });
      setTotalAmount(list.reduce((a, v) => (a = a + v.totalprice), 0));
      setTotalDue(list.reduce((a, v) => (a = a + v.balance), 0));
      setSupplierlist(list);
    });
  }, []);

  const handleChangePage = (event, newPage) => {
    setPages(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPages(0);
  };

  return (
    <div className="purchase-payables-container">
      <div className="payables-title">Payables</div>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="payables table" size="small">
          <TableHead>
            <TableRow>
              <TableCell style={{ width: 50, padding: "12px 16px" }} />
              <TableCell>Supplier</TableCell>
              <TableCell>Due</TableCell>
              <TableCell>Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {supplierlist
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((e, i) => (
                <GRNlist key={i} row={e} data={grns} />
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10]}
        component="div"
        count={supplierlist.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        sx={{
          borderTop: "1px solid #f1f5f9",
          ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows": {
            fontSize: "0.8rem",
            color: "#64748b",
          },
        }}
      />
    </div>
  );
};

function GRNlist(props) {
  const { row, data } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell style={{ padding: "8px 16px" }}>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
            sx={{ color: "#94a3b8" }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell>{row.supplier}</TableCell>
        <TableCell>
          <span style={{ color: "#334155" }}>
            {currency}{" "}
            <NumericFormat
              displayType={"text"}
              value={row.balance}
              decimalScale={2}
              fixedDecimalScale={true}
              disabled={true}
              thousandSeparator={true}
              thousandsGroupStyle={thousandsdisplay}
            />
          </span>
        </TableCell>
        <TableCell>
          <span style={{ color: "#334155" }}>
            {currency}{" "}
            <NumericFormat
              displayType={"text"}
              value={row.totalprice}
              decimalScale={2}
              fixedDecimalScale={true}
              disabled={true}
              thousandSeparator={true}
              thousandsGroupStyle={thousandsdisplay}
            />
          </span>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          style={{ padding: 0 }}
          colSpan={6}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Table size="small" aria-label="purchases">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontSize: "0.75rem", fontWeight: 600, color: "#64748b" }}>GRN Id</TableCell>
                  <TableCell sx={{ fontSize: "0.75rem", fontWeight: 600, color: "#64748b" }}>Purchase Order Id</TableCell>
                  <TableCell sx={{ fontSize: "0.75rem", fontWeight: 600, color: "#64748b" }}>Balance</TableCell>
                  <TableCell sx={{ fontSize: "0.75rem", fontWeight: 600, color: "#64748b" }}>Total price</TableCell>
                  <TableCell sx={{ fontSize: "0.75rem", fontWeight: 600, color: "#64748b" }}>Date</TableCell>
                  <TableCell sx={{ fontSize: "0.75rem", fontWeight: 600, color: "#64748b" }}>Elapsed</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((historyRow, index) =>
                  historyRow.supplierid === row.supplierid && historyRow.balance !== 0 ? (
                    <TableRow
                      style={{
                        background: `${moment(historyRow.createdAt, "YYYY-MM-DD").diff(
                          moment(new Date(), "YYYY-MM-DD"),
                          "days"
                        ) < 0
                          ? "rgba(251, 191, 36, 0.08)"
                          : ""
                          }`,
                      }}
                      key={index}
                    >
                      <TableCell component="th" scope="row">
                        <Link
                          to={{ pathname: "/viewgrnitems" }}
                          state={{
                            id: historyRow.customgrnid,
                            temp: false,
                          }}
                          style={{ color: "#6366f1", textDecoration: "none", fontWeight: 500 }}
                        >
                          {historyRow.customgrnid}
                        </Link>
                      </TableCell>
                      <TableCell>
                        <Link
                          to={{ pathname: "/viewpurchaseorder" }}
                          state={{ id: historyRow.custompoid }}
                          style={{ color: "#6366f1", textDecoration: "none", fontWeight: 500 }}
                        >
                          {historyRow.custompoid}
                        </Link>
                      </TableCell>
                      <TableCell style={{ color: "#ef4444", fontWeight: 500 }}>
                        <NumericFormat
                          displayType={"text"}
                          value={historyRow.balance}
                          decimalScale={2}
                          fixedDecimalScale={true}
                          disabled={true}
                          thousandSeparator={true}
                          thousandsGroupStyle={thousandsdisplay}
                        />
                      </TableCell>
                      <TableCell>
                        <NumericFormat
                          displayType={"text"}
                          value={historyRow.totalprice}
                          decimalScale={2}
                          fixedDecimalScale={true}
                          disabled={true}
                          thousandSeparator={true}
                          thousandsGroupStyle={thousandsdisplay}
                        />
                      </TableCell>
                      <TableCell align="center" sx={{ fontSize: "0.82rem" }}>
                        {moment(historyRow.createdAt).format("DD-MM-YYYY HH:mm:ss")}
                      </TableCell>
                      <TableCell align="center" sx={{ fontSize: "0.82rem" }}>
                        {moment(historyRow.createdAt, "YYYY-MM-DD").diff(
                          moment(new Date(), "YYYY-MM-DD"),
                          "days"
                        )}
                      </TableCell>
                    </TableRow>
                  ) : (
                    ""
                  )
                )}
              </TableBody>
            </Table>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default Payables;
